// A lead's qualification as the app treats it — one rule for the leads list,
// the lead's Lead Status badge and the activity form (the backend's
// face-to-face gate in routes/leadActivities.js uses the same date).

// When lead qualification shipped. Leads created before it never had the
// question asked, so a "pending" one already being worked counts as
// qualified. Newer leads are qualified only when someone says so — before
// this date limit, one follow-up was enough to show "Qualified".
export const QUALIFICATION_INTRODUCED_AT = new Date('2026-05-10T18:15:45.000Z');

/** 'qualified' | 'not_qualified' | 'pending' */
export function qualificationOf({ qualificationStatus, status, createdAt } = {}) {
  if (qualificationStatus === 'qualified' || qualificationStatus === 'not_qualified') return qualificationStatus;
  const legacy = status && status !== 'new' && createdAt && new Date(createdAt) < QUALIFICATION_INTRODUCED_AT;
  return legacy ? 'qualified' : 'pending';
}
